'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SocialYoutube = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8.036 2.4c.455 0 5.035.017 6.224.343a2 2 0 0 1 1.41 1.41C16 5.354 16 7.806 16 8.002v.04c-.001.282-.02 2.645-.33 3.82a2 2 0 0 1-1.41 1.411c-1.177.31-5.673.328-6.208.33h-.104c-.534-.002-5.02-.021-6.208-.343a2 2 0 0 1-1.41-1.41C.02 10.686 0 8.313 0 8.03v-.056c.001-.282.02-2.645.33-3.821a2.05 2.05 0 0 1 1.41-1.424c1.19-.313 5.768-.328 6.223-.329zm-1.63 3.203V10.4l4.164-2.399z",
            clipRule: "evenodd"
        })
    }));
});
SocialYoutube.displayName = "SocialYoutube";

export { SocialYoutube, SocialYoutube as default };
